import React from 'react';

function PrintFooter({ headerFooterInfo }) {
  return (
    <>
      <>
        <table
          id="eSign"
          width="734px"
          align="left"
          border={0}
          cellSpacing={0}
          cellPadding={0}
          style={{ marginTop: 15 }}
        >
          <tbody>
            <tr width="734px">
              <td
                width="719px"
                style={{ padding: '5px 0px 0px 15px' }}
                align="left"
              >
                <h5>
                  <i
                    dangerouslySetInnerHTML={{
                      __html: headerFooterInfo?.signDetail?.signStr
                        ? headerFooterInfo?.signDetail?.signStr
                        : '',
                    }}
                  ></i>
                </h5>
              </td>
            </tr>
            <tr width="734px">
              <td
                width="719px"
                style={{ padding: '5px 0px 0px 15px' }}
                align="left"
              >
                <h5>
                  <i
                    dangerouslySetInnerHTML={{
                      __html: headerFooterInfo?.signDetail?.coSignStr
                        ? headerFooterInfo?.signDetail?.coSignStr
                        : '',
                    }}
                  ></i>
                </h5>
              </td>
            </tr>
          </tbody>
        </table>
        {/* <table
          id="footer"
          width="734px"
          align="left"
          border={0}
          cellSpacing={0}
          cellPadding={0}
          style={{ marginTop: 35 }}
        >
          <tbody>
            <tr width="734px">
              <td width="534px" style={{ paddingTop: 5 }}>
                <h3>{headerFooterInfo?.header?.clinicName}</h3>
              </td>
              <td width="200px" style={{ paddingTop: 5 }}>
                <img
                  src={headerFooterInfo?.footer?.signature_text}
                  width="280px;"
                  height="76px"
                  alt=""
                />
              </td>
            </tr>
            <tr width="734px">
              <td width="534px" style={{ paddingTop: 5 }}>
                &nbsp;
              </td>
              <td width="200px" style={{ paddingTop: 5 }}>
                e-Signed by:
              </td>
            </tr>
          </tbody>
        </table> */}
        <table
          id="footer_2"
          width="734px"
          align="left"
          border={0}
          cellSpacing={0}
          cellPadding={0}
          style={{ marginTop: 15 }}
        >
          <tbody>
            <tr width="734px">
              <td
                width="734px"
                style={{ padding: '2px 0px', backgroundColor: '#dadada' }}
                align="center"
              >
                <h6>Powered By Medgre, www.medgre.com </h6>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    </>
  );
}

export default PrintFooter;
